import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Box,
} from "@mui/material";
import { marked } from "marked";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Fade } from "react-awesome-reveal";
import {
  IHeaderFooterData,
  IPaymentData,
  ITermsConditionsData,
} from "../../exports/interfaces";

const FaqsDetails = (props: {
  headerFooterData: IHeaderFooterData[];
  termsConditionsData: ITermsConditionsData[];
}) => {
  const [paymentData, setPaymentData] = useState<IPaymentData[]>([]);
  const [expandedPaymant, setExpandedPayment] = useState<string | false>(false);

  useEffect(() => {
    const processMarkdown = async () => {
      const data = await Promise.all(
        props.termsConditionsData.map(async (data) => ({
          id: `panel${data?.id}`,
          title: data?.title,
          description: await marked(data?.description || ""),
        }))
      );
      setPaymentData(data);
    };

    processMarkdown();
  }, [props.termsConditionsData]);

  useEffect(() => {
    if (paymentData.length > 0) {
      setExpandedPayment(paymentData[paymentData.length - 1].id);
    }
  }, [paymentData]);

  const handlePaymentChange =
    (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedPayment(isExpanded ? panel : false);
    };
  // const [expandedReservation, setExpandedReservation] = useState<
  //   string | false
  // >(ReservationData[ReservationData.length - 1].id);

  // const handleReservationChange =
  //   (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
  //     setExpandedReservation(isExpanded ? panel : false);
  //   };
  return (
    <>
      <Fade direction="down" triggerOnce={true}>
        <div
          id="page_content_wrapper"
          className="noheader"
          style={{ padding: "unset" }}
        >
          <div className="inner">
            {/* <!-- Begin main content --> */}
            <div className="inner_wrapper">
              <div
                className="sidebar_content full_width nopadding custom-row-element"
                style={{ display: "flex", justifyContent: "space-evenly" }}
              >
                <div
                  className="sidebar_content page_content custom-terms-page_content"
                  style={{ width: "55dvw", marginTop: "unset" }}
                >
                  <div
                    data-elementor-type="wp-post"
                    data-elementor-id="770"
                    className="elementor elementor-770"
                    data-elementor-settings="[]"
                  >
                    <div className="elementor-inner">
                      <div className="elementor-section-wrap">
                        <section
                          className="elementor-section elementor-top-section elementor-element elementor-element-c8d681f elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                          data-id="c8d681f"
                          data-element_type="section"
                          data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
                        >
                          <div className="elementor-container elementor-column-gap-default">
                            <div className="elementor-row">
                              <div
                                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-03a5609"
                                data-id="03a5609"
                                data-element_type="column"
                                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                              >
                                <div className="elementor-column-wrap elementor-element-populated">
                                  <div className="elementor-widget-wrap">
                                    <div
                                      className="elementor-element elementor-element-1a8b0ed elementor-widget elementor-widget-heading"
                                      data-id="1a8b0ed"
                                      data-element_type="widget"
                                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <h2 className="widgettitle">
                                          <span>
                                            Frequently Asked Questions
                                          </span>
                                        </h2>
                                        <p className="elementor-heading-title elementor-size-default">
                                          {
                                            props?.headerFooterData[0]
                                              ?.header
                                          }
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-625b11b elementor-widget elementor-widget-accordion"
                                      data-id="625b11b"
                                      data-element_type="widget"
                                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                      data-widget_type="accordion.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div
                                          className="elementor-accordion"
                                          role="tablist"
                                        >
                                          <div className="elementor-accordion-item">
                                            {paymentData.map((item) => (
                                              <Accordion
                                                key={item.id}
                                                expanded={
                                                  expandedPaymant === item.id
                                                }
                                                onChange={handlePaymentChange(
                                                  item.id
                                                )}
                                              >
                                                <AccordionSummary
                                                  expandIcon={
                                                    <ExpandMoreIcon />
                                                  }
                                                  aria-controls={`${item.id}-content`}
                                                  id={`${item.id}-header`}
                                                >
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <IconButton edge="start">
                                                      {expandedPaymant ===
                                                      item.id ? (
                                                        <RemoveIcon />
                                                      ) : (
                                                        <AddIcon />
                                                      )}
                                                    </IconButton>
                                                    <div
                                                      id="elementor-tab-title-1031"
                                                      className="elementor-tab-title"
                                                      data-tab="1"
                                                      role="tab"
                                                      aria-controls="elementor-tab-content-1031"
                                                    >
                                                      <span
                                                        className="elementor-accordion-icon elementor-accordion-icon-left"
                                                        aria-hidden="true"
                                                      >
                                                        <i className="elementor-accordion-icon-closed fa fa-plus-square-o"></i>
                                                        <i className="elementor-accordion-icon-opened fa fa-minus-square-o"></i>
                                                      </span>
                                                      {/* <a
                                                      className="elementor-accordion-title"
                                                      href="/"
                                                    > */}
                                                      <strong>
                                                        {item.title}
                                                      </strong>
                                                      {/* </a> */}
                                                    </div>
                                                  </Box>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                  <div
                                                    id="elementor-tab-content-1031"
                                                    className="elementor-tab-content elementor-clearfix"
                                                    data-tab="1"
                                                    role="tabpanel"
                                                    aria-labelledby="elementor-tab-title-1031"
                                                    style={{
                                                      padding: "0px 16px",
                                                    }}
                                                  >
                                                    <p>
                                                      <div
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            item.description,
                                                        }}
                                                      />
                                                    </p>
                                                  </div>
                                                </AccordionDetails>
                                              </Accordion>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-1a8b0ed elementor-widget elementor-widget-heading"
                                      data-id="1a8b0ed"
                                      data-element_type="widget"
                                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <p className="elementor-heading-title elementor-size-default">
                                          {
                                            props?.headerFooterData[0]
                                              ?.footer
                                          }
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                        {/* <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-b9b2d6f elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="b9b2d6f"
                        data-element_type="section"
                        data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-559ab3b"
                              data-id="559ab3b"
                              data-element_type="column"
                              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-af5a57e elementor-widget elementor-widget-heading"
                                    data-id="af5a57e"
                                    data-element_type="widget"
                                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                    data-widget_type="heading.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <h3 className="elementor-heading-title elementor-size-default custom-terms-h3">
                                        Reservation
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-element elementor-element-58f1580 elementor-widget elementor-widget-accordion"
                                    data-id="58f1580"
                                    data-element_type="widget"
                                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                    data-widget_type="accordion.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div
                                        className="elementor-accordion"
                                        role="tablist"
                                      >
                                        <div className="elementor-accordion-item">
                                          {ReservationData.map((item) => (
                                            <Accordion
                                              key={item.id}
                                              expanded={
                                                expandedReservation === item.id
                                              }
                                              onChange={handleReservationChange(
                                                item.id
                                              )}
                                            >
                                              <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls={`${item.id}-content`}
                                                id={`${item.id}-header`}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <IconButton edge="start">
                                                    {expandedReservation ===
                                                    item.id ? (
                                                      <RemoveIcon />
                                                    ) : (
                                                      <AddIcon />
                                                    )}
                                                  </IconButton>
                                                  <div
                                                    id="elementor-tab-title-1031"
                                                    className="elementor-tab-title"
                                                    data-tab="1"
                                                    role="tab"
                                                    aria-controls="elementor-tab-content-1031"
                                                  >
                                                    <span
                                                      className="elementor-accordion-icon elementor-accordion-icon-left"
                                                      aria-hidden="true"
                                                    >
                                                      <i className="elementor-accordion-icon-closed fa fa-plus-square-o"></i>
                                                      <i className="elementor-accordion-icon-opened fa fa-minus-square-o"></i>
                                                    </span>
                                                      <strong>
                                                        {item.title}
                                                      </strong>
                                                  </div>
                                                </Box>
                                              </AccordionSummary>
                                              <AccordionDetails>
                                                <div
                                                  id="elementor-tab-content-1031"
                                                  className="elementor-tab-content elementor-clearfix"
                                                  data-tab="1"
                                                  role="tabpanel"
                                                  aria-labelledby="elementor-tab-title-1031"
                                                >
                                                  <p>{item.description}</p>
                                                </div>
                                              </AccordionDetails>
                                            </Accordion>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- End main content --> */}
          </div>
          <br className="clear" />
        </div>
      </Fade>
    </>
  );
};

export default FaqsDetails;
